// API set to implement
module.exports = [
    'config',

    'isApiSupported',
    'getApisVersion',
    'getUA',
    'Semver',
    'checkAuthorization',

    'getFingerprint',
    'getUserInfo',
    'getDeviceInfo',
    'login',
    'logout',
    'sendSMS',
    'getContactList',
    'pickContact',

    'getCity',
    'getLocationCity',
    'getLocation',
    'getNetworkType',
    'pickCity',

    'share',
    'configShare',

    'openWebview',
    'closeWebview',
    'jumpWebview',

    'setTitle',
    'setImageTitle',
    'setNavButtons',
    'setNavigationBarHidden',
    'setBackgroundColor',
    'setBouncesEnabled',
    'setStatusBarStyle',
    'setPullDown',
    'stopPullDown',
    'setLLButton',
    'setLRButton',
    'setRRButton',
    'setRLButton',
    'setSearchBar',
    'scanQRCode',
    'showKeyboard',

    'store',
    'retrieve',

    'alert',
    'confirm',
    'prompt',
    'sendLog',

    'chooseImage',
    'previewImage',
    'uploadImage',
    'downloadImage',

    'publish',
    'subscribe',
    'unsubscribe',

    'setResult',
    'getResult',

    'shareImage',
    'sendLog',
    
    'shareMiniProgram',
    'addRequestSignature',
    'stopLocating',
    
    'setStorage',
    'getStorage',
    'clearStorage',

    'getAppInfo',
    'getWifiInfo',
    'getImageInfo',

    'setupEvent',

    'setTitleBar',
    'resetTitleBar',
    'setTitleBarAction',
    'addTitleBarElement',
    'removeTitleBarElement',
    'replaceTitleBarElement',

    'requestPermission',
    'openPage',
    'jumpPage',
    'closePage',

    'getServiceInfo'
  ];
